import { getIsPreview } from '../utils/isPreview';
export const useIsPreview = () => {
  const {
    isPreview
  } = getIsPreview();
  return isPreview;
};